import { Component, OnInit, Output, EventEmitter,ViewChild } from '@angular/core';
import {
  AccessCodeAndClientSecret,
  AuthFormNotificationType,
  AuthFormType
} from '@shared/models/auth.interface';
import { AppService, LoadingService } from '@shared/services/core';
import { AuthService } from '@shared/services/auth/auth.service';
import { BehaviorSubject} from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { SnackbarService } from '@shared/services/core/snackbar.service';
import { MatDialog } from '@angular/material/dialog';
import { PasswordPolicyComponent } from './password-policy/password-policy.component';

@Component({
  selector: 'app-other-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  @Output() notify = new EventEmitter<AuthFormNotificationType>();
  @Output() result = new EventEmitter<
    { code: string; logo: string } | undefined
  >();
  notClosed: boolean = false;
  notificationShown: boolean = false;
  notificationType: AuthFormNotificationType = 'ACCESSCODE_ERROR';
  currentForm: AuthFormType = 'ACCESSCODE';
  currentFormHeading: string = 'page.login.heading';
  lastForm$ = new BehaviorSubject<AuthFormType>('ACCESSCODE');
  readonly defaultLogo: string = '/assets/images/entireonhire-logo.svg';
  userLogo: string = this.defaultLogo;
  accessCode: string = '';
  companyCode: string | undefined;
  private _qurParam: string = '';

  constructor(
    private loadingService: LoadingService,
    private appService: AppService,
    private authService: AuthService,
    private _activeRoute: ActivatedRoute,
    private snackbarService: SnackbarService,
    public dialog: MatDialog
  ) {
    this.loadingService.showLoading();
  }

  ngOnInit(): void {
    this._qurParam = this._activeRoute.snapshot.queryParams['se'];
    this.companyCode = this._activeRoute.snapshot.queryParams['ac'];
    this.loadingService.stopLoading();
    this.clearBackButtonHistory();

    let authStatusType = this._activeRoute.snapshot.queryParams['authStatus'];
    if (authStatusType) {
      this.showNotificationFor(authStatusType);
    }

    if (this._qurParam) {
      this.snackbarService.showErrorSnackBar(
        'Session Expired',
        'We apologize for the inconvenience, but your session has ended. Please log in again.',
        ''
      );
    }
    if (this.companyCode) {
      this.proceedForLogin();
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(PasswordPolicyComponent, {
      width: '100%',
      maxWidth: '470px',
      panelClass: 'password-policy-dialog',
    });

    
  }

  closeMessageBox() {
    this.notClosed = false;
  }

  toggleToForm(form: AuthFormType) {
    this.notificationShown = false;
    this.lastForm$.next(this.currentForm); // for animation.
    this.currentForm = form;
    this.changeFormHeading(form);
  }
  changeFormHeading(currentForm: string) {
    switch (currentForm) {
      case 'FORGOTUSERID': {
        this.currentFormHeading = 'page.login.form.forgotUserId.heading';
        break;
      }
      case 'RECOVERY': {
        this.currentFormHeading = 'page.setPassword.heading';
        break;
      }
      case 'FORGOT_PASSWORD': {
        this.currentFormHeading = 'page.forgot-password.heading';
        break;
      }
      default: {
        this.currentFormHeading = 'page.login.heading'; // fallback value
        break;
      }
    }
  }
  
  toggleToPreviousForm() {
    this.notificationShown = false;
    this.lastForm$.next(this.currentForm); // for animation.
    
    if (this.currentForm === 'LOGIN') {
      this.accessCode = '';
      this.userLogo = this.defaultLogo;
      this.currentForm = 'ACCESSCODE';
    } else {
      this.currentForm = 'LOGIN';
    }
    this.changeFormHeading(this.currentForm);
  }

  updateData(data?: { code: string; logo: string }) {
    this.userLogo = data?.logo ?? this.defaultLogo;
    this.accessCode = data?.code || '';
    if (this.notificationShown) this.notificationShown = false;
    this.lastForm$.next('ACCESSCODE');
    this.currentForm = 'LOGIN';
  }

  showNotificationFor(notificationType: AuthFormNotificationType | null,msg?: string) {
    if (!notificationType) {
      this.notificationShown = false;
      return;
    }
    if (notificationType === 'PASS_RECOVERY_SUCCESS') {
      setTimeout(() => {
        this.notificationShown = false;
        this.toggleToForm('LOGIN');
      }, 6000);
    
      
    }
    if (notificationType === 'LOGIN_ERROR') {
console.log('Login Error Notification',msg);
    }
    this.notificationType = notificationType;
   this.notificationShown = true;
  }

  clearBackButtonHistory() {
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', function () {
      history.pushState(null, document.title, location.href);
    });
  }

  proceedForLogin() {
    const requestBody: AccessCodeAndClientSecret = {
      code: this.companyCode!
      // clientId: this.appService.getAppSettings().cfgPkg.cfgC,
      // clientSecret:
      //   this.appService.getAppSettings().cfgPkg.cfgD,
    };
    this.loadingService.showLoading();
    this.authService
      .checkAccessToken(requestBody)
      .pipe()
      .subscribe({
        next: (response) => {
          if (response && response.data) {
            this.accessCode=this.companyCode||"";
            this.userLogo=`data:image/jpg;base64, ${response.data.clientLogo}`
            this.toggleToForm('LOGIN')
            // this.result.next({
            //   code: requestBody.code,
            //   logo: `data:image/jpg;base64, ${response.data.clientLogo}`,
            // });
          }
          this.loadingService.stopLoading();
        },
        error: (err: Error) => {
          if (err.message === 'Unauthorized') {
            this.showNotificationFor('ACCESS_DENIED');
          } else this.showNotificationFor('ACCESSCODE_ERROR');
          this.loadingService.stopLoading();
        },
      });
  }


}


